import React from "react";
import { useParams } from "react-router-dom";
import { useGetProcessUIData } from "../../../hooks/entity";
import { useLmcUserView } from "../../../contexts/AuthContext";
import LoadingPage from "../../public/LoadingPage";
import FeedbackFilter from "./FeedbackFilter";
import UnknownProcessTypeView from "../error/UnknownProcessTypeView";

const FeedbackFilterWrapper: React.FC = () => {
  const { processId } = useParams<{ processId: string }>();
  const { dispatch } = useLmcUserView();

  const {
    data: processData,
    isLoading,
    isError,
  } = useGetProcessUIData(processId as string, {
    enabled: !!processId,
    onSuccess: (data) => {
      dispatch({
        type: "ENTITY",
        payload: data,
      });
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError || !processData) {
    return <UnknownProcessTypeView processType={undefined} />;
  }

  const googleReview = processData?.process_data?.google_places;
  const googleReviewUrl =
    googleReview?.review_link_enabled && googleReview?.google_place_id
      ? `https://search.google.com/local/writereview?placeid=${googleReview.google_place_id}`
      : undefined;

  const entityIdentification =
    processData?.entity_data?.entity_identification || "";

  return (
    <FeedbackFilter
      googleReviewUrl={googleReviewUrl}
      entityIdentification={entityIdentification}
    />
  );
};

export default FeedbackFilterWrapper;
